"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var containers = {
    symbol: function (_a) {
        var children = _a.children, symbol = _a.symbol;
        return react_1.default.createElement("div", { className: "storybook-forms-input-symbol storybook-forms-input-symbol-" + symbol }, children);
    },
    default: function (_a) {
        var children = _a.children;
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    },
};
var Input = function (_a) {
    var id = _a.id, className = _a.className, name = _a.name, _b = _a.type, type = _b === void 0 ? 'text' : _b, value = _a.value, onChange = _a.onChange, placeholder = _a.placeholder, symbol = _a.symbol, min = _a.min, max = _a.max, disabled = _a.disabled, step = _a.step, autoFocus = _a.autoFocus, readOnly = _a.readOnly;
    var Container = containers[symbol ? 'symbol' : 'default'];
    return react_1.default.createElement(Container, { symbol: symbol },
        react_1.default.createElement("input", { id: id, name: name, type: type, value: value || '', onChange: function (event) { return onChange(event.target.value); }, placeholder: placeholder, className: "storybook-forms-input" + (className ? " " + className : ''), min: min, max: max, disabled: disabled, step: step, autoFocus: autoFocus, readOnly: readOnly }));
};
exports.Input = Input;
exports.Input.propTypes = {
    /**
     * The id of the Input
     */
    id: prop_types_1.default.string,
    /**
     * The name of the Input
     */
    name: prop_types_1.default.string,
    /**
     * The value of the Input
     */
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    /**
     * The onChange function of the Input
     */
    onChange: prop_types_1.default.func,
    /**
     * The placeholder of the Input
     */
    placeholder: prop_types_1.default.string,
    /**
     * The symbol that should be prefixed to the Input
     */
    symbol: prop_types_1.default.string,
};
